const IcPreviousPage = () => {
    return (<svg width="17" height="16" viewBox="0 0 17 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
        <path d="M9.99335 4L10.9333 4.94L7.88002 8L10.9333 11.06L9.99335 12L5.99335 8L9.99335 4Z" fill="currentColor"/>
        </svg>
        )
}

export default IcPreviousPage